import TopGame from "./TopGame";
import BottomGame from "./BottomGame";
import gameCarousel from "../../JSON/mob-games.json";
import deskGames from "../../JSON/desktop-games.json";
import GameSwiper from "./GameSwiper";
import PromotionSection from "./PromotionSection";

// Top Games \\

function Games({ device, sectionToDisplay }) {
  return (
    <>
      {sectionToDisplay && <PromotionSection device={device} />}
      {device ? (
        <div id="mobile_games">
          {gameCarousel.slice(sectionToDisplay ? 1 : 0).map((games, i) => (
            <div key={i}>
              <span className="game-title">{games.title} </span>
              <GameSwiper games={games.games} />
            </div>
          ))}
        </div>
      ) : (
        <div id="desktop_games" className="mt-3">
          {!sectionToDisplay && (
            <div>
              <span className="game-title"> Mejores Juegos </span>
              <div className="top_games_conatiner">
                {deskGames.top_games.map((item, key) => (
                  <TopGame key={key} banner={item} />
                ))}
              </div>
            </div>
          )}

          <div>
            <span className="game-title"> Nuevos Juegos </span>
            <div className="bottom_conatiner">
              {deskGames.bottom_games.map((item, key) => (
                <BottomGame key={key} banner={item} />
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Games;
